export const isObject = (value: unknown): boolean => (typeof value === 'object' && !Array.isArray(value) && value !== null)

export const hasProp = (obj: unknown, prop: string): boolean => { // @deprecated
  return isObject(obj) && Object.prototype.hasOwnProperty.call(obj, prop)
}

export const isFunc = (func: CallableFunction): boolean => func && {}.toString.call(func) === '[object Function]'

export const pick = (obj: Record<string, unknown>): any => {
  const newObj: any = {}
  Object.keys(obj).map((key: string) => {
    if (obj[key]) {
      newObj[key] = obj[key]
    }
    return key
  })
  return newObj
}

type FuncObject = Record<string, any>
export const removeObjectKeys = (obj: FuncObject, keysToRemove: string[]): FuncObject => {
  const newObj: FuncObject = {}
  for (const key in obj) {
    if (!keysToRemove.includes(key)) {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

export const filterObjectByKeys = (obj: Record<any, any>, keys: any[]): Record<any, any> => {
  const result = {} as Record<any, any>

  Object.entries(obj).forEach(item => {
    const key = item[0]
    const value = item[1]

    if (keys.includes(key)) {
      result[key] = value
    }
  })

  return result
}
